import React, {useContext} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import './style.scss'
import moment from 'moment';
import 'moment/locale/he';
import {AppContext} from "../../../Utils/AppContext";
import {DialogTitle} from "@material-ui/core";


moment.locale('he');

export default function SaveChangeAddressDialog({
                                                    isOpen,
                                                    fromInputAddress,
                                                    toAddress,
                                                    numberOfChanges,
                                                    onClose,
                                                    onCloseDontAskAgain,
                                                    onSave
                                                }) {
    const appContext = useContext(AppContext);

    return (
        <Dialog
            className={"save-change-address-dialog " + (appContext.direction === "rtl" ? "dialog-rtl" : "dialog-ltr")}
            open={isOpen}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
            PaperProps={{className: "save-change-address-dialog-paper"}}>
            <DialogTitle className="save-change-address-dialog-title">
                {
                    numberOfChanges > 1 ?
                        <React.Fragment>
                            זיהינו ששינית את הכתובת הזו כבר ב{numberOfChanges} הזמנות שונות,
                            <br/>
                        </React.Fragment>
                        :
                        null
                }
                <React.Fragment>
                    האם תרצה לשמור את שינוי הכתובת באופן אוטומטי עבור ההזמנות הבאות?
                </React.Fragment>
            </DialogTitle>
            <DialogContent>
                אם הכתובת נכנסת כ-<b><u>{fromInputAddress}</u></b>
                <br/>
                היא תשתנה ל-<b><u>{toAddress}</u></b>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <Button variant="contained" onClick={onCloseDontAskAgain} className="dont-ask-again-button">
                    אל תשאל שוב עבור כתובת זו
                </Button>
                <Button variant="contained" onClick={onClose} className="close-button">
                    סגור
                </Button>
                <Button variant="contained" color="primary" onClick={onSave} className="save-button">
                    שמור
                </Button>
            </DialogActions>
        </Dialog>
    );
}